import request from '@/utils/request'

export function upload (data) {
  request.defaults.timeout = 180000;
  return request({
    url: '/uploadProtocolSite',
    method: 'post',
    data,
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  }).finally( () =>  { request.defaults.timeout = 5000 })
}
